/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import { useQuery } from '@tanstack/react-query';
import { THumanResourcesFilters } from '../../components/HumanResources/human-resources';
import fetchHumanResources from '../api/fetchHumanResources';
import { HUMAN_RESOURCES_QUERY_NAME } from '../constants';

const useHumanResources = (query: THumanResourcesFilters, token: string, options?: any) => {
  if (options !== undefined && typeof options !== 'object') {
    throw new Error('The options is not an object');
  }

  const queryOptions = {
    ...options,
    enabled: Boolean(token) && (options?.enabled ?? true),
  };

  return useQuery([HUMAN_RESOURCES_QUERY_NAME, query], () => fetchHumanResources(query, token), queryOptions);
};

export default useHumanResources;
